import React from 'react';
import { path } from 'ramda';

import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';
import { DefinitionField } from 'components/common/fields/DefinitionField';
import ActionDescriptionField from 'components/cards/education/action/ActionDescriptionField';
import EducationStages from '../EducationStages';

export const ActionCard = ({ item: { stages, participants, description }, item }) => {
    const project = path(['posname', 0, 'text'], item);

    return (
        <div>
            <DefinitionHeader translate="common.general" iconType='info-outline' />
            <div className="panel-view">
                <DefinitionField
                    translate="education.action.headers.project"
                    text={project}
                />
            </div>

            { participants && (
                <div>
                    <DefinitionHeader translate="education.action.participants" iconType="user-group" />
                    <div className="panel-view">
                        {participants.map((person, index) => (
                            <div key={index}>
                                {person.text}
                            </div>
                        ))}
                    </div>
                </div>
            )}

            { description && (
                <ActionDescriptionField descriptions={[description]} />
            )}

            <EducationStages stages={stages} />
        </div>
    );
}
